export default `
fragment ParagraphVideoYoutube on ParagraphVideoYoutube {
  id
  uuid
  entityBundle
  title
  youtube_url
}
`
